// @ts-expect-error migrate upstream file
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-expect-error migrate upstream file
import { reportingReferenceResolvers } from 'reporting-data/public/reference-resolvers';
export default ProvideReferenceResolvers(reportingReferenceResolvers);